import { Controller } from "@hotwired/stimulus"

// Asks for the page again in a few seconds, while something is being settled
// elsewhere.
//
// The Treasury counts gold on Stripe's word, which arrives by webhook to
// the worker a moment after the browser comes back from paying. The page
// says "Weighing…" and, rather than leaving the Dragon Keeper to press the
// link, looks again itself until the server draws the section without this
// controller on it. A ceiling on the looking, so a word that never comes does
// not keep a tab busy all night.
export default class extends Controller {
  static values = {
    after: { type: Number, default: 3 },
    limit: { type: Number, default: 20 }
  }

  connect() {
    const looked = Number(sessionStorage.getItem(this.key) || 0)
    if (looked >= this.limitValue) return

    this.timer = setTimeout(() => {
      sessionStorage.setItem(this.key, String(looked + 1))
      window.location.replace(window.location.href)
    }, this.afterValue * 1000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  get key() {
    return `lairlings:look-again:${window.location.pathname}${window.location.search}`
  }
}
